export default __webpack_public_path__ + "static/portfolio_gallery_14-9fbd3c03f4b10ab7ecba1801cd378841.jpg";